<template>
	<div>
		<Title>{{ $t("seo.pages.home.title") }}</Title>
		<Meta v-if="globalConfig.isBlue" name="description" :content="$t('seo.pages.home.bluedescription')" />
		<Meta v-else name="description" :content="$t('seo.pages.home.description')" />
		<Link rel="canonical" :href="`https://${globalConfig.host}${$route.fullPath}`" />
		<Link v-if="globalConfig.isBlue" rel="icon" type="image/x-icon" href="/blue-favicon.ico?v3" />
		<Link v-else rel="icon" type="image/x-icon" href="/favicon.ico?v3" />
		<Meta v-if="globalConfig.isBlue" name="facebook-domain-verification" content="jzj4rz7dg3rtfkfhj9ayh3mwr2rm8w" />
		<Meta property="og:url" :content="`https://${globalConfig.host}${$route.fullPath}`" />
		<Meta property="og:type" content="website" />
		<Meta
			property="og:locale"
			:content="`${$i18n.locale}_${$i18n.locale == 'en' ? 'US' : $i18n.locale.toUpperCase()}`"
		/>
		<Meta property="og:title" :content="$t('seo.pages.home.title')" />
		<Meta v-if="globalConfig.isBlue" property="og:description" :content="$t('seo.pages.home.bluedescription')" />
		<Meta v-else property="og:description" :content="$t('seo.pages.home.description')" />
		<Meta
			property="og:image"
			content="https://res.cloudinary.com/djbs/image/upload/v1669288084/content/DreamJobs/Graphics/ogimage_dreamjobs.png"
		/>
		<Meta property="og:image:type" content="image/jpeg" />
		<Meta property="og:image:width" content="1200" />
		<Meta property="og:image:height" content="628" />

		<HeroMain />
		<BannerContainer banner-type="frontend-landing-banner" class="banner-section" v-slot="{ content }">
			<section
				class="container relative flex flex-col md:flex-row justify-center mx-5 sm:mx-8 md:mx-auto my-8"
				v-html="content"
			></section>
		</BannerContainer>
		<SectionsJobCategories v-if="!isAuth" />
		<SectionsJobs v-if="!isAuth" />
		<SectionsDailyFavoriteJobs />
		<SectionsJobsAsUser v-if="isAuth" />
		<SectionsCounties />
		<SectionsLocations />
		<SectionsRegCta />
		<SectionsCompanies />
		<SectionsLogos />
		<SectionsBlog />
		<SectionsTestimonials />
	</div>
</template>

<script setup lang="ts">
const isAuth = useState("isAuth");
</script>
